import { useApi } from '@/composables/useApi'

const api = useApi()

export default {
  namespaced: true,
  state: {
    PastaAtual: {},
    videos: [],
    AllVideosMain: [],
    videoEditAtual: {},
  },
  getters: {
    getVideoEditAtual(state) {
      return state.videoEditAtual
    },
  },
  mutations: {
    setVideosMain(state, payload) {
      state.AllVideosMain = payload
    },
    removeVideoMain(state, videoId) {
      state.AllVideosMain = state.AllVideosMain.filter(v => v.id !== videoId)
    },
    setVideoEditAtual(state, payload) {
      state.videoEditAtual = payload
    },
    resetVideoEditAtual(state) {
      state.videoEditAtual = {}
    },
  },
  actions: {
    async listarVideos({ commit, rootState }) {
      const userId = (rootState.User && rootState.User.user && rootState.User.user.id)
        || (JSON.parse(localStorage.getItem('userData') || '{}').id)
      if (!userId) return

      const raw = JSON.parse(localStorage.getItem('folderATUAL'))
      const folderId = raw && typeof raw === 'object' ? (raw.id || 0) : (Number(raw) || 0)

      const params = { id_folder: folderId }

      try {
        const resp = await api.get(`/vslUserId/${userId}`, { params })
        const formData = resp.data
        formData.forEach(v => { v.is_selected = false })
        commit('setVideosMain', formData)
      } catch (error) {
        console.error('[listarVideos]', error)
      }
    },
  },
}
